import {Component} from '@angular/core';
import {environment} from 'src/environments/environment';


@Component({
    selector: 'jhi-login-modal',
    templateUrl: './login.component.html'
})
export class JhiLoginModalComponent  {

    selectedClient=environment.login

    constructor(){

    }

    ngOnInit(){
        console.log(this.selectedClient);
        console.log(environment.environment);

    }

}